import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getEndDateDST, getStartDateDST } from '../../../utils/urlFunctions';
import { getTimeIntervalWithTimezone } from '../../../utils/time';
import { weightMeasurementUnits } from '../../../constants/dashboard.constants';
import useChickenDashboardUnits from '../store/useChickenDashboardUnits';

export default function useChickenDashboardDistReqParams() {
  const restaurantUuid = useSelector(state => state.chickenDashboard?.restaurantUuid);
  const startDate = useSelector(state => state.chickenDashboard?.startDate);
  const endDate = useSelector(state => state.chickenDashboard?.endDate);
  const timeInterval = useSelector(state => state.chickenDashboard?.timeInterval);
  const timezone = useSelector(state => state.chickenDashboard?.timezone);
  const cookingMethod = useSelector(state => state.chickenDashboard?.cookingMethod);
  const chickenTypes = useSelector(state => state.chickenDashboard?.chickenTypes);
  const startTimeInterval = useSelector(state => state.chickenDashboard?.startTimeInterval);
  const endTimeInterval = useSelector(state => state.chickenDashboard?.endTimeInterval);
  const units = useChickenDashboardUnits();
  
  const startTime = useMemo(() => {
    const hasStartDate = startDate !== 'select';
    
    if ((hasStartDate || timeInterval) && timezone) {
      return getStartDateDST(startDate, timeInterval, timezone);
    }
    
    return null;
  }, [startDate, timeInterval, timezone]);
  
  const endTime = useMemo(() => {
    const hasEndDate = endDate !== 'select';
    
    if ((hasEndDate || timeInterval) && timezone) {
      return getEndDateDST(endDate, timeInterval, timezone);
    }
    
    return null;
  }, [endDate, timeInterval, timezone]);
  
  return useMemo(() => {
    const hasChickenTypes = !isEmpty(chickenTypes);
    const hasReqParams = startTime && endTime && timezone && hasChickenTypes && restaurantUuid;

    if (!hasReqParams) {
      return null;
    }
    
    return {
      restaurantUuid: restaurantUuid !== 'select' ? restaurantUuid : null,
      startTime,
      endTime,
      cookingMethod: cookingMethod,
      materials: chickenTypes.join(),
      startTimeInterval: getTimeIntervalWithTimezone(startTimeInterval, timezone),
      endTimeInterval: getTimeIntervalWithTimezone(endTimeInterval, timezone),
      weightMeasurementUnit: weightMeasurementUnits[units],
    };
  }, [
    restaurantUuid,
    startTime,
    endTime,
    timezone,
    cookingMethod,
    chickenTypes,
    startTimeInterval,
    endTimeInterval,
    units,
  ]);
}
